import { enhancedApi } from '.'
import type { AssistantSkillRun } from '.'

export type {
  AssistantContextRef,
  AssistantSkillSchedule,
  AssistantSkillScheduleList,
  AssistantSkillScheduleCreateParams,
  AssistantSkillScheduleUpdateParams,
  AssistantSkillRun,
  AssistantSkillRunList,
  AssistantSkillRunTranscriptTurn,
  AssistantSkillRunTranscript
} from '.'

export {
  useListSkillSchedulesQuery,
  useCreateSkillScheduleMutation,
  useGetSkillScheduleQuery,
  useUpdateSkillScheduleMutation,
  useDeleteSkillScheduleMutation,
  useListSkillScheduleRunsQuery,
  useGetSkillScheduleRunQuery,
  useGetSkillScheduleRunTranscriptQuery
} from '.'

// `run-now` is not yet part of the generated OpenAPI spec, so it stays hand-written here.
const assistantSkillScheduleApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    runSkillScheduleNow: build.mutation<
      AssistantSkillRun,
      { scheduleId: string; 'X-Organization-Id': string }
    >({
      query: (queryArg) => ({
        url: `/api/v1/assistant/skill-schedules/${queryArg.scheduleId}/run-now`,
        method: 'POST',
        headers: {
          'X-Organization-Id': queryArg['X-Organization-Id']
        }
      }),
      invalidatesTags: ['assistant-skill-schedule-api']
    })
  }),
  overrideExisting: false
})

export const { useRunSkillScheduleNowMutation } = assistantSkillScheduleApi
